import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageHero from '../components/PageHero';

const { FiCompass, FiEye, FiHeart } = FiIcons;

const values = [
  {
    icon: FiCompass,
    title: 'Practical direction',
    text: 'We turn big possibilities into clear, achievable next steps.'
  },
  {
    icon: FiEye,
    title: 'Every person seen',
    text: 'We recognize talent, dignity, and potential in every young person.'
  },
  {
    icon: FiHeart,
    title: 'Community first',
    text: 'We grow stronger through service, partnership, and shared effort.'
  }
];

function About() {
  return (
    <>
      <PageHero
        eyebrow="About us"
        title="A future shaped by confidence and community."
        text="Legacy of Immortals exists to expand access to the knowledge, encouragement, and experience young people need to thrive."
        image="/images/1.jpg"
      />

      <section className="story-section">
        <p className="eyebrow">Why we exist</p>
        <div>
          <h2>Skills create choices. Support creates momentum.</h2>
          <p>
            Young people facing economic and social barriers are often asked to
            enter adulthood without access to the practical preparation others
            take for granted. We help close that gap.
          </p>
          <p>
            Through skills education, workforce preparation, public outreach,
            and volunteer service, participants gain tools they can carry into
            employment, relationships, and civic life.
          </p>
        </div>
      </section>

      <section className="values-grid">
        {values.map((value) => (
          <motion.article key={value.title} whileHover={{ y: -6 }}>
            <SafeIcon icon={value.icon} />
            <h3>{value.title}</h3>
            <p>{value.text}</p>
          </motion.article>
        ))}
      </section>

      <section className="regional-section">
        <div className="region-image">
          <img
            src="/images/2.jpg"
            alt="Young students learning together in a classroom"
          />
        </div>
        <div>
          <p className="eyebrow">Rooted in the Pacific Northwest</p>
          <h2>Local relationships. Lasting impact.</h2>
          <p>
            We meet families where they are, participate in public events, and
            work alongside organizations that share our commitment to the
            region's youth.
          </p>
        </div>
      </section>
    </>
  );
}

export default About;